/**
 *  There are times when a component requires a function to be passed as a prop,
 *  likely an event handler. However, in some cases we don't need that. Rather than
 *  passing an inline lambda (which breaks React pure components optimisation), we
 *  re-use this function.
 */
export default function doNothing() {}
